import getUser from "./getUser";

const userServices = {
  getUser,
};

export default userServices;
